<!--时控定义--旧的--原则上-->
<template>
	<treeBody>
		<listView slot="tree" :dataList='sceneList' @checkItem="nowScene = $event" :autoCheckIndex='0'></listView>
		<div slot="body">
			<div class="buttonLine">
				<iconButton icoName="wedoButton/add.png" buttonText="添加时控" @buttonClick="addScene"></iconButton>
				<iconButton icoName="wedoButton/delete.png" buttonText="删除时控" @buttonClick="deleteScene"></iconButton>
				<iconButton icoName="wedoButton/edit.png" buttonText="修改周期" @buttonClick="editScene" v-if="nowScene != undefined"></iconButton>
				<iconButton icoName="wedoButton/add.png" buttonText="添加设备" @buttonClick="addDevice" v-if="nowScene != undefined"></iconButton>
				<iconButton icoName="wedoButton/delete.png" buttonText="删除设备" @buttonClick="deleteDevice" v-if="nowScene != undefined"></iconButton>
				<iconButton icoName="wedoButton/confirm.png" buttonText="提交保存" @buttonClick="updateScene"></iconButton>
			</div>
			<infoList ref="deviceList" style="height: calc(100% - 0.47rem)" :columns='columns' :dataList="nowDeviceList"
			 :pageLen='nowDeviceList.length < 20 ? 20 : nowDeviceList.length' :totalSize="nowDeviceList.length" :fillAll="true"
			 :showIndex="false" @checkItem="nowDevice = $event" @dblclick="dblClick"></infoList>
		</div>
		<div class="dialog-window" v-show="showAdd">
			<div class="dialog-body" style="position: relative;">
				<p style="background: white;padding: 10px;font-weight: bold;font-size: 16px;text-align: left;">创建时控</p>
				<div class="flexStart">
					<span>时控名称 : </span>
					<input type="text" v-model="nowAddName">
				</div>
				<div class="flexStart">
					<span>通讯间隔 : </span>
					<input type="number" v-model="nowAddInterval">
					<span>(毫秒)</span>
				</div>
				<div class="radioGroup">
					<p style="margin-bottom: 10px;">周期:</p>
					<label><input name="interval" type="radio" :value="0" v-model="timeControlType" /> 每天 </label>
					<label><input name="interval" type="radio" :value="1" v-model="timeControlType" /> 每周 </label>
					<label><input name="interval" type="radio" :value="2" v-model="timeControlType" /> 每月 </label>
					<label><input name="interval" type="radio" :value="3" v-model="timeControlType" /> 周期性 </label>
					<label><input name="interval" type="radio" :value="4" v-model="timeControlType" /> 一次性 </label>
				</div>
				<div v-if="timeControlType == 0">
					<p>请选择每天执行的时间 : <input type="time" v-model="dayTime" class="timeInput"></p>
				</div>
				<div v-else-if="timeControlType == 1">
					<p>请选择每周指定日期执行的时间，如果不想启用点击时间输入框中的 x 清除时间</p>
					<p>周一:<input type="time" v-model="weekTime['周一']" class="timeInput"> 周二:<input type="time" v-model="weekTime['周二']"
						 class="timeInput"></p>
					<p>周三:<input type="time" v-model="weekTime['周三']" class="timeInput"> 周四:<input type="time" v-model="weekTime['周四']"
						 class="timeInput"></p>
					<p>周五:<input type="time" v-model="weekTime['周五']" class="timeInput"> 周六:<input type="time" v-model="weekTime['周六']"
						 class="timeInput"></p>
					<p>周日:<input type="time" v-model="weekTime['周日']" class="timeInput"></p>
				</div>
				<div v-else-if="timeControlType == 2">
					<p>请选择每月执行的日期和时间</p>
					<p>每月(1-31)日:<input type="number" min="1" max="31" v-model="monthDay" class="timeInput"> 时间：<input type="time"
						 v-model="monthTime" class="timeInput"></p>
				</div>
				<div v-else-if="timeControlType == 3">
					<p>请选择时间间隔：</p>
					<p>每隔：<input type="number" v-model="dayLong" class="timeInput" min="0"> 天 <input type="number" v-model="hourLong"
						 class="timeInput" min="0">
						小时 <input type="number" v-model="minuteLong" class="timeInput" min="0"> 分</p>
				</div>
				<div v-else="timeControlType == 4">
					<p>请选择一个时间:</p>
					<p> <input type="datetime-local" v-model="targetTime"> </p>
				</div>
				<div style="position: absolute;bottom: 20px;left: 0;width: 100%;" class="flexCenter">
					<button class="nomalButton specialButton" @click="cancel">× 取消</button>
					<button class="nomalButton" @click="confirm">√ 确定</button>
				</div>
			</div>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import listView from '@/components/module/selection/base/listView.vue'
	export default {
		components: {
			treeBody,
			iconButton,
			infoList,
			listView
		},
		props: {},
		data() {
			return {
				sceneList: [],
				nowScene: undefined,
				sceneIdToDeviceList: {},
				columns: [{
					name: '设备名称',
					key: 'name',
					getTdStyleMethod(item, index) {
						return {
							'text-align': 'left'
						}
					}
				}, {
					name: '遥控指令(双击切换)',
					key: 'command',
					getTdStyleMethod(item, index) {
						return {
							cursor: 'pointer'
						}
					}
				}],
				nowDevice: undefined,
				showAdd: false,
				isAdd: false,
				nowAddName: '',
				nowAddInterval: 2000,
				timeControlType: 0,
				dayTime: '00:00',
				weekTime: {
					'周一': '00:00',
					'周二': '00:00',
					'周三': '00:00',
					'周四': '00:00',
					'周五': '00:00',
					'周六': '00:00',
					'周日': '00:00'
				},
				monthDay: 1,
				monthTime: '00:00',
				dayLong: 1,
				hourLong: 0,
				minuteLong: 0,
				targetTime: undefined
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.getSceneTree()
		},
		destroyed() {},
		computed: {
			nowDeviceList() {
				if (this.nowScene == undefined) {
					return []
				}
				return getValueIfNoNull(this.sceneIdToDeviceList[this.nowScene.id], [])
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowUnitVirtualDeviceTree() {
				return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
			},
			nowUnitVirtualDeviceTreeList() {
				return treeToList(this.nowUnitVirtualDeviceTree, 'next', item => !isempty(item.next)).filter(item => item.entityName ==
					"VirtualDevicePojo")
			},
			nowCheckIdList() {
				//当前时控下哪些设备是已经被选中的，如果是选中的，设备名字就一样，只认名字，因为没有设备no
				var idList = []
				var deviceIdList = this.nowDeviceList.map(item => item.id)
				var deviceList = this.nowUnitVirtualDeviceTreeList.filter(item => deviceIdList.includes(item.id))
				return deviceList.map(item => item.no)
			}
		},
		watch: {
			nowCheckIdList(nv, ov) {

			},
			nowScene(nv, ov) {
				if (ov != undefined && (nv == undefined || ov.id != nv.id)) {
					this.$set(this.sceneIdToDeviceList, ov.id, ov.next)
				}
			},
			monthDay(nv, ov) {
				if (nv < 1 || nv > 31) {
					this.monthDay = 1
				}
			}
		},
		methods: {
			getSceneTree() {
				this.$api.lightOldApi.getLightSceneTree(respon => {
					//移除里面的时控
					respon = respon.filter(item => item.sceneType == 1)
					for (var i = 0, len = respon.length; i < len; i++) {
						if (respon[i].interval == undefined) {
							respon[i].interval = 2000
						}
						var next = respon[i].next
						for (var i1 = 0, len1 = next.length; i1 < len1; i1++) {
							var item = next[i1]
							//获取他的指令
							if (item.hasOwnProperty('next') && item.next[0] != undefined) {
								item.command = item.next[0].percent == 1 ? '开' : '关'
							} else {
								item.command = '无效'
							}
						}
						this.$set(this.sceneIdToDeviceList, respon[i].id, next)
					}
					if (respon.length > 0) {
						if (this.nowScene == undefined) {
							this.nowScene = respon[0]
						} else {
							var target = respon.find(item => item.id == this.nowScene.id),
								undefined
							if (target != undefined) {
								this.nowScene = copy(target)
							} else {
								this.nowScene = undefined
							}
						}
					} else {
						this.nowScene = undefined
					}
					this.sceneList = respon
				})
			},
			addScene() {
				this.isAdd = true
				this.showAdd = true
			},
			deleteScene() {
				if (this.nowScene == undefined) {
					this.$dialogMethod.showMessage('请先选中一个时控!')
					return
				}
				this.$dialogMethod.openAgreeDialog('删除时控', '确定要删除时控【' + this.nowScene.name + '】吗?', respon => {
					this.$api.lightOldApi.deleteScene(this.nowScene.id, respon => {
						this.$dialogMethod.showMessage('删除成功!')
						this.getSceneTree()
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			addDevice() {
				//绑定虚拟设备
				this.$dialogMethod.getMultipleSelectionDialog().setGetIdMethod(item => item.entityName == "VirtualDevicePojo" ?
					item.id : 'group' +
					item.id)
				this.$dialogMethod.openMultipleSelectionDialog('选择虚拟设备', this.nowUnitVirtualDeviceTree.next, this.nowCheckIdList,
					respon => {
						respon = respon.filter(item => item.entityName == "VirtualDevicePojo")
						//idMap
						var idMap = {}
						for (var i = 0, len = this.nowDeviceList.length; i < len; i++) {
							var item = this.nowDeviceList[i]
							idMap[item.id] = item
						}
						//为已存在的设备添加数据
						respon = respon.map(item => {
							if (idMap[item.id] != undefined) {
								return idMap[item.id]
							}
							return item
						})
						for (var i = 0, len = respon.length; i < len; i++) {
							//默认是开
							var item = respon[i]
							if (item.entityName == "VirtualDevicePojo" && !item.hasOwnProperty('command')) {
								item.command = '开'
							}
						}
						//添加设备，但是先不提交
						this.$set(this.sceneIdToDeviceList, this.nowScene.id, respon)
					})
			},
			deleteDevice() {
				if (this.nowDevice == undefined) {
					this.$dialogMethod.showMessage('请先选中一个设备!')
					return
				}
				//删除但是不提交
				var tempId = this.nowDevice.id
				var list = this.sceneIdToDeviceList[this.nowScene.id]
				list = list.filter(item => {
					return item.id != tempId
				})
				this.$set(this.sceneIdToDeviceList, this.nowScene.id, list)
			},
			updateScene() {
				//提交设备列表
				var deviceIdList = this.nowDeviceList.map(item => item.id)
				var needRemoveList = []
				var commandList = this.nowDeviceList.map(item => {
					if (item.command == '无效') {
						return undefined
					}
					return item.command == '开' ? 1 : 0
				}).filter((item, index) => {
					//移除无效的设备
					if (item == undefined) {
						needRemoveList.push(index)
						return false
					}
					return true
				})
				deviceIdList = deviceIdList.filter((item, index) => {
					return !needRemoveList.includes(index)
				})
				//先删所有设备再添加
				var saveCallback = respon => {
					this.$dialogMethod.showMessage('设备提交成功!')
					this.getSceneTree()
				}
				var deleteCallback = respon => {
					if (!isempty(deviceIdList)) {
						this.$api.lightOldApi.saveDevice(this.nowScene.id, deviceIdList.join(','), commandList.join(','), saveCallback,
							saveCallback)
					} else {
						saveCallback()
					}
				}
				if (!isempty(this.nowScene.next.map(item => item.id).join(','))) {
					this.$api.lightOldApi.deleteDevice(this.nowScene.id, this.nowScene.next.map(item => item.id).join(','),
						deleteCallback,
						deleteCallback)
				} else {
					deleteCallback()
				}
			},
			dblClick(item) {
				if (item) {
					if (item.command == '无效') {
						this.$dialogMethod.showMessage('无效的设备')
						return
					}
					this.$set(item, 'command', item.command == '开' ? '关' : '开')
					this.$refs.deviceList.nowCheckIndex = -1
				}
			},
			resetDefaultValue() {
				this.timeControlType = 0
				this.nowAddInterval = 2000
				this.nowAddName = undefined
				this.dayTime = '00:00'
				this.weekTime = {
					'周一': '00:00',
					'周二': '00:00',
					'周三': '00:00',
					'周四': '00:00',
					'周五': '00:00',
					'周六': '00:00',
					'周日': '00:00'
				}
				this.monthDay = 1
				this.monthTime = '00:00'
				this.dayLong = 1
				this.hourLong = 0
				this.minuteLong = 0
				this.targetTime = undefined
			},
			cancel() {
				this.showAdd = false
				this.resetDefaultValue()
			},
			editScene() {
				//设置当前数据
				this.isAdd = false
				this.nowAddName = this.nowScene.name
				this.nowAddInterval = this.nowScene.interval
				this.timeControlType = this.nowScene.timeControlType
				switch (this.nowScene.timeControlType) {
					case 0:
						this.dayTime = this.nowScene.dayTimeInfo.subByFirstChar(' ')
						break
					case 1:
						this.weekTime['周一'] = this.nowScene.isMonday == 1 ? this.nowScene.mondayInfo.subByFirstChar(' ') : undefined
						this.weekTime['周二'] = this.nowScene.isTuesday == 1 ? this.nowScene.tuesdayInfo.subByFirstChar(' ') : undefined
						this.weekTime['周三'] = this.nowScene.isWednesday == 1 ? this.nowScene.wedinesdayInfo.subByFirstChar(' ') :
							undefined
						this.weekTime['周四'] = this.nowScene.isThursday == 1 ? this.nowScene.thursdayInfo.subByFirstChar(' ') : undefined
						this.weekTime['周五'] = this.nowScene.isFriday == 1 ? this.nowScene.fridayInfo.subByFirstChar(' ') : undefined
						this.weekTime['周六'] = this.nowScene.isSaturday == 1 ? this.nowScene.saturdaysInfo.subByFirstChar(' ') : undefined
						this.weekTime['周日'] = this.nowScene.isSunday == 1 ? this.nowScene.sundayInfo.subByFirstChar(' ') : undefined
						break
					case 2:
						this.monthDay = parseInt(this.nowScene.monthTimeInfo.subByFirstChar('-').subByFirstChar('-').substring(0, 2))
						this.monthTime = this.nowScene.monthTimeInfo.subByFirstChar(' ')
						break
					case 3:
						this.dayLong = this.nowScene.day
						this.hourLong = this.nowScene.hour
						this.minuteLong = this.nowScene.minute
						break
					case 4:
						this.targetTime = this.nowScene.disposableTimeInfo
						break
				}
				this.showAdd = true
			},
			confirm() {
				if (isempty(this.nowAddName)) {
					this.$dialogMethod.showMessage('名称不能为空！')
					return
				}
				if (isempty(this.nowAddInterval) || this.nowAddInterval < 1000) {
					this.$dialogMethod.showMessage('通讯间隔不能为空或者小于1000毫秒！')
					return
				}
				var callback = respon => {
					this.$dialogMethod.showMessage(this.isAdd ? '创建成功!' : '更新成功!')
					this.showAdd = false
					this.resetDefaultValue()
					this.getSceneTree()
				}
				var faildCallback = respon => {
					this.$dialogMethod.showMessage(respon)
				}
				var dateStart = new Date().formatByDate('-') + ' '
				var sceneId = this.isAdd ? undefined : this.nowScene.id
				var serialnum = getValueIfNoNull(this.sceneList[this.sceneList
					.length -
					1], {
					serialnum: 0
				}).serialnum + 1
				switch (this.timeControlType) {
					case 0:
						//每天的
						if (isempty(this.dayTime)) {
							this.$dialogMethod.showMessage('必须选择一个有效的时间！')
							return
						}
						this.$api.lightOldApi.saveDayTimeControl(sceneId, this.nowAddName, serialnum, this.nowAddInterval, dateStart +
							this.dayTime, callback,
							faildCallback)
						break
					case 1:
						//每周的
						var allNull = true
						eachObject(this.weekTime, item => {
							if (!isempty(item)) {
								allNull = false
							}
						})
						if (allNull) {
							this.$dialogMethod.showMessage('一周中必须至少有一天指定运行时间！')
							return
						}
						//每周的
						this.$api.lightOldApi.saveWeekTimeControl(sceneId, this.nowAddName, serialnum, this.nowAddInterval, isempty(this.weekTime[
								'周一']) ? 0 : 1, isempty(this.weekTime['周一']) ?
							undefined : dateStart +
							this.weekTime['周一'], isempty(this.weekTime['周二']) ? 0 : 1, isempty(this.weekTime['周二']) ? undefined : dateStart +
							this.weekTime['周二'], isempty(this.weekTime['周三']) ? 0 : 1, isempty(this.weekTime['周三']) ? undefined : dateStart +
							this.weekTime['周三'], isempty(this.weekTime['周四']) ? 0 : 1, isempty(this.weekTime['周四']) ? undefined : dateStart +
							this.weekTime['周四'], isempty(this.weekTime['周五']) ? 0 : 1, isempty(this.weekTime['周五']) ? undefined : dateStart +
							this.weekTime['周五'], isempty(this.weekTime['周六']) ? 0 : 1, isempty(this.weekTime['周六']) ? undefined : dateStart +
							this.weekTime['周六'], isempty(this.weekTime['周日']) ? 0 : 1, isempty(this.weekTime['周日']) ? undefined : dateStart +
							this.weekTime['周日'], callback,
							faildCallback)
						break
					case 2:
						//每月的,一律按一月份处理
						if (isempty(this.monthTime)) {
							this.$dialogMethod.showMessage('时间不能为空！')
							return
						}
						var monthDateTime = '2019-01-' + (this.monthDay < 10 ? '0' : '') + this.monthDay + ' ' + this.monthTime
						this.$api.lightOldApi.saveMonthTimeControl(sceneId, this.nowAddName, serialnum, this.nowAddInterval,
							monthDateTime, callback,
							faildCallback)
						break
					case 3:
						//周期性
						this.$api.lightOldApi.saveIntervalTimeControl(sceneId, this.nowAddName, serialnum, this.nowAddInterval,
							this.dayLong, this.hourLong, this.minuteLong, callback,
							faildCallback)
						break
					case 4:
						//周期性
						if (isempty(this.targetTime)) {
							this.$dialogMethod.showMessage('时间不能为空！')
							return
						}
						this.$api.lightOldApi.saveDisposableTimeControl(sceneId, this.nowAddName, serialnum, this.nowAddInterval,
							this.targetTime, callback,
							faildCallback)
						break
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/dialog.css");

	>>>ul.list-body>li.isCheck {
		color: #5273C3 !important;
	}

	.radioGroup>label {
		margin-right: 20px;
	}

	.timeInput {
		margin-left: 20px;
		width: 100px;
		text-align: center;
	}

	.dialog-body>div {
		padding: 10px;
	}
</style>
